import { render, staticRenderFns } from "./4ActivitateMediu.vue?vue&type=template&id=ab5fef1c"
import script from "./4ActivitateMediu.vue?vue&type=script&lang=js"
export * from "./4ActivitateMediu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports